import { spinWheelActivityCheckApi, spinWheelActivityClaimApi } from '../../api/activity'

export default {
  state: {
    prizeListOrigin: [],
    prizeClaimed: [],
    prizeDetails: {
      status: '',
      code: '',
      remainingspins: '',
      reward: '',
      quantity: '',
      message: '',
    }
  },
  getters: {},
  mutations: {
    setPrizeListOrigin(state, data) {
      state.prizeListOrigin = data
    },
    setPrizeClaimed(state, data) {
      state.prizeClaimed = data
    },
    setPrizeDetails(state, data) {
      state.prizeDetails = data
    },
  },
  actions: {
    getPrizeListOrigin(context, params) {
      spinWheelActivityCheckApi(params).then(res => {
        let finalData = res.data.map(item => {
          if (!item.hasOwnProperty('icon')) {
            item.icon = require('@/static/images/spinwheel/icon-money.png')
          }
          return item
        })
        context.commit("setPrizeListOrigin", finalData);
        context.commit("setPrizeDetails", res);
      })
    },
    claimPrize(context, params) {
      // let getPaymentType = context.rootState.recharge.paymentList.payment_type
      // let res = context.rootState.prizeClaimed;
      // let addedData = res.push(params)
      
      // // UPDATE PRIZE CLAIMED LIST AFTER PRIZE CLAIM
      // context.commit("setPrizeClaimed", addedData);

      // // UPDATE RECHARGE UPON PRIZE CLAIM
      // context.dispatch('setRecharge',{
      //   attach: null,
      //   bank_code: "NA",
      //   money: context.rootState.prizeDetails.prizeAmt,
      //   payment_desc: null,
      //   payment_id: 0,
      //   payment_type: getPaymentType[0].type
      // })
      spinWheelActivityClaimApi(params).then(res => {
        if (res.status == "success") {
          this.$message.success( res.message );
        }
        else {
          this.$message.error( res.message );
        }
        
        // context.commit('setPrizeDetails', res);
      }).catch(err => {
        this.$message.error(err.response.data.message);
      })
    }
  }
}


// WEBPACK FOOTER //
// ./src/vuex/modules/spinWheel.js